import React from "react";
import { useLockBodyScroll } from "@/src/hooks/useLockBodyScroll";
import { ModalContainerProps } from "./types";

const ModalContainer: React.FC<ModalContainerProps & { smallPopup?: boolean }> = ({
  isOpen,
  onClose,
  children,
  background,
  smallPopup = false,
}) => {
  useLockBodyScroll(isOpen);

  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div
        className={`modal-content ${smallPopup ? "small-popup" : ""}`}
        style={background ? { background } : {}}
      >
        <button onClick={onClose} className="modal-close-button">
          ✕
        </button>
        {children}
      </div>
    </div>
  );
};

export default ModalContainer;
